/* tslint:disable */
/* eslint-disable */
/**
 * Pfa API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HorseRegister
 */
export interface HorseRegister {
    /**
     * 
     * @type {number}
     * @memberof HorseRegister
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof HorseRegister
     */
    bookerId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HorseRegister
     */
    bookerEmail?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HorseRegister
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof HorseRegister
     */
    breed: string;
    /**
     * 
     * @type {string}
     * @memberof HorseRegister
     */
    gender: string;
    /**
     * 
     * @type {string}
     * @memberof HorseRegister
     */
    color: string;
    /**
     * 
     * @type {Date}
     * @memberof HorseRegister
     */
    birthday: Date;
    /**
     * 
     * @type {string}
     * @memberof HorseRegister
     */
    owner: string;
    /**
     * 
     * @type {string}
     * @memberof HorseRegister
     */
    mother: string;
    /**
     * 
     * @type {string}
     * @memberof HorseRegister
     */
    father: string;
    /**
     * 
     * @type {Date}
     * @memberof HorseRegister
     */
    registerDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof HorseRegister
     */
    remark?: string | null;
}

/**
 * Check if a given object implements the HorseRegister interface.
 */
export function instanceOfHorseRegister(value: object): value is HorseRegister {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('breed' in value) || value['breed'] === undefined) return false;
    if (!('gender' in value) || value['gender'] === undefined) return false;
    if (!('color' in value) || value['color'] === undefined) return false;
    if (!('birthday' in value) || value['birthday'] === undefined) return false;
    if (!('owner' in value) || value['owner'] === undefined) return false;
    if (!('mother' in value) || value['mother'] === undefined) return false;
    if (!('father' in value) || value['father'] === undefined) return false;
    return true;
}

export function HorseRegisterFromJSON(json: any): HorseRegister {
    return HorseRegisterFromJSONTyped(json, false);
}

export function HorseRegisterFromJSONTyped(json: any, ignoreDiscriminator: boolean): HorseRegister {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'bookerId': json['bookerId'] == null ? undefined : json['bookerId'],
        'bookerEmail': json['bookerEmail'] == null ? undefined : json['bookerEmail'],
        'name': json['name'],
        'breed': json['breed'],
        'gender': json['gender'],
        'color': json['color'],
        'birthday': (new Date(json['birthday'])),
        'owner': json['owner'],
        'mother': json['mother'],
        'father': json['father'],
        'registerDate': json['registerDate'] == null ? undefined : (new Date(json['registerDate'])),
        'remark': json['remark'] == null ? undefined : json['remark'],
    };
}

export function HorseRegisterToJSON(json: any): HorseRegister {
    return HorseRegisterToJSONTyped(json, false);
}

export function HorseRegisterToJSONTyped(value?: HorseRegister | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'bookerId': value['bookerId'],
        'bookerEmail': value['bookerEmail'],
        'name': value['name'],
        'breed': value['breed'],
        'gender': value['gender'],
        'color': value['color'],
        'birthday': ((value['birthday']).toISOString().substring(0,10)),
        'owner': value['owner'],
        'mother': value['mother'],
        'father': value['father'],
        'registerDate': value['registerDate'] == null ? undefined : ((value['registerDate']).toISOString()),
        'remark': value['remark'],
    };
}

